import React, { Component } from 'react';

import AuthService from '../../state/auth.service';

import AuthenticatedNavbar from './authenticated';
import PublicNavbar from './public';

class Navbar extends Component {
    render() {
        let navbar = <PublicNavbar />;

        if (window.location.href.endsWith('/account/signin')) {
            navbar = null;
        } else if (AuthService.isAuthenticated()) {
            navbar = <AuthenticatedNavbar />;
        }

        return navbar;
    }
}

export default Navbar;
